module.exports = __webpack_public_path__ + "sit/20260421123616/img/logo_200.6488dd39.png";